import { SnackbarProps } from '@mui/material';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { SnackbarProvider } from 'notistack';
import { RouterProvider } from 'react-router';
import IotsApiProvider from './components/Providers/IotsApiProvider';
import LanguageProvider from './components/Providers/LanguageProvider';
import { router } from './router/router';
import AuthManagerProvider from './components/Providers/AuthManagerProvider';

const queryClient = new QueryClient();

const snackbarPosition: SnackbarProps['anchorOrigin'] = {
  horizontal: 'right',
  vertical: 'top',
};

const App = () => {
  return (
    <AuthManagerProvider>
      <IotsApiProvider>
        <QueryClientProvider client={queryClient}>
          <LanguageProvider>
            <SnackbarProvider anchorOrigin={snackbarPosition} maxSnack={5}>
              <RouterProvider router={router} />
            </SnackbarProvider>
          </LanguageProvider>
        </QueryClientProvider>
      </IotsApiProvider>
    </AuthManagerProvider>
  );
};

export default App;
